import { GiacenzaDialogComponent } from './../../components/giacenza-dialog/giacenza-dialog.component';
import { dataTable } from './../../models/dataTable.model';
import { BookService } from 'src/app/services/book.service';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { iUser } from 'src/app/models/user.model';
import { MovimentiLibrerieDialogComponent } from 'src/app/components/movimenti-librerie-dialog/movimenti-librerie-dialog.component';
import {
  debounceTime,
  distinctUntilChanged,
} from 'rxjs/operators';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-statistiche',
  templateUrl: './statistiche.component.html',
  styleUrls: ['./statistiche.component.scss'],
})
export class StatisticheComponent
  implements OnInit, OnDestroy
{
  @Input() user: iUser = null;
  subscriptions: Subscription[] = [];
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  searchSubscription: Subscription;
  searchCtrl = new FormControl();
  constructor(
    private bookservice: BookService,
    private dialog: MatDialog
  ) {}
  selectedType: number = 88;
  limit = '30';
  types = [
    { cod: 88, description: 'SellIn' },
    { cod: 89, description: 'SellOut' },
  ];
  loadData = false;
  loadDataLibrerie = false;
  dataTableLibrerie: dataTable = {
    header: [
      'Ragione Sociale',
      'Indirizzo',
      'Città',
      'Provincia',
      'N',
    ],
    rows: [],
  };

  dataTable: dataTable = {
    header: ['Titolo', 'Quantità'],
    rows: [],
  };
  graphOption = {
    title: {
      left: 'center',
    },
    tooltip: {
      trigger: 'item',
    },

    series: [
      {
        type: 'pie',
        radius: [10, 100],
        center: ['50%', '50%'],
        roseType: 'area',
        itemStyle: {
          borderRadius: 8,
        },
        data: [],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
  };
  giacenza: dataTable = {
    header: [
      'descrizione',
      'giacenza',
      'ultimo aggiornamento',
    ],
    rows: [],
  };
  ngOnInit(): void {
    const start = moment().subtract(1, 'M').toDate();
    const stop = moment().toDate();
    this.range.controls['start'].setValue(start);
    this.range.controls['end'].setValue(stop);
    this.doReport();
    const sub = 
      this.searchCtrl.valueChanges
        .pipe(debounceTime(1000), distinctUntilChanged())
        .subscribe((data) => {
          this.getBestLibrerie(data);
        });

    this.subscriptions.push(sub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((el) => {
      if(el){
        el.unsubscribe();
      }
    })
  }

  /** i top libri */
  getBestSellers() {
    const start = moment(this.range.value.start).format(
      'YYYYMMDD'
    );
    const stop = moment(this.range.value.end).format(
      'YYYYMMDD'
    );
    this.loadData = true;
    const sub = this.bookservice
      .getBestSellerBook(
        start,
        stop,
        this.selectedType,
        this.limit
      )
      .subscribe((data: Array<any>) => {
        this.graphOption.series[0].data = [];
        this.dataTable.rows = [];
        this.dataTable.rowClick = [];
        data.forEach((item) => {
          this.dataTable.rows.push([
            item.titolo,
            Number(item.quantita),
          ]);
          this.dataTable.rowClick.push([
            item.titolo,
            item.codice,
          ]);
          this.graphOption.series[0].data.push({
            value: item.quantita,
            name: item.titolo,
          });
        });
        this.loadData = false;
      });
    this.subscriptions.push(sub);
  }

  /**getBestLibrerie */
  getBestLibrerie(filter: string = '') {
    const start = moment(this.range.value.start).format(
      'YYYYMMDD'
    );
    const stop = moment(this.range.value.end).format(
      'YYYYMMDD'
    );
    this.loadDataLibrerie = true;
    const sub = this.bookservice
      .getBestSellerLibrerie(
        start,
        stop,
        this.selectedType,
        this.limit,
        filter
      )
      .subscribe((data: Array<any>) => {
        this.dataTableLibrerie.rows = [];
        this.dataTableLibrerie.rowClick = [];
        data.forEach((item) => {
          this.dataTableLibrerie.rows.push([
            item.ragione_sociale,
            item.indirizzo,
            item.citta,
            item.prov,
            Number(item.quantita),
          ]);
          this.dataTableLibrerie.rowClick.push([
            item.ragione_sociale,
            item.libreria,
          ]);
        });
        this.loadDataLibrerie = false;
      });

      this.subscriptions.push(sub);
  }
  /**
   * do report
   */
  doReport(code = null) {
    if (code) {
      this.selectedType = code;
    }
    this.getBestSellers();
    this.getBestLibrerie();
  }

  /**
   * giacenze top libri
   * @param $event
   */
  openStatsBook($event) {
    const dialogRef = this.dialog.open(
      GiacenzaDialogComponent,
      {
        data: { codice: $event[1], titolo: $event[0] },
        height: 'auto',
        width: 'auto',
      }
    );
    dialogRef
      .afterClosed()
      .toPromise()
      .then((data) => {});
  }

  /**
   * Dialog movimenti librerie
   * @param $event
   */
  openMovimentiBookstore($event) {
    if (this.user.isEditore()) {
      const start = moment(this.range.value.start).format(
        'YYYYMMDD'
      );
      const stop = moment(this.range.value.end).format(
        'YYYYMMDD'
      );
      const dialogRef = this.dialog.open(
        MovimentiLibrerieDialogComponent,
        {
          data: {
            titolo: $event[0],
            start: start,
            stop: stop,
            type: this.selectedType,
            limit: this.limit,
            libreria: $event[1],
          },
          height: 'auto',
          width: 'auto',
        }
      );
      dialogRef
        .afterClosed()
        .toPromise()
        .then((data) => {});
    }
  }

  formatData(data) {
    return moment(data, 'YYYY-MM-DD').format('DD-MM-YYYY');
  }
}
